import { render } from "./reset_email.vue?vue&type=template&id=e135c29a&scoped=true"
import script from "./reset_email.vue?vue&type=script&lang=js"
export * from "./reset_email.vue?vue&type=script&lang=js"

import "./reset_email.vue?vue&type=style&index=0&id=e135c29a&scoped=true&lang=scss"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e135c29a"]])

export default __exports__